import api from "@/lib/api";
import { toast } from "sonner";
import { dec, eur } from "@/components/excelVoce/format";

const Th = ({ children, right }) => <th className={`py-2 px-2 text-[10px] uppercase tracking-widest font-semibold text-slate-500 ${right ? "text-right" : "text-left"}`}>{children}</th>;

export const EsecutoriMdo = ({ rigaId, esecutori, um, canEdit, onChanged }) => {
  if (!esecutori.length) return null;
  const setCrit = async (key, criterio) => {
    try { await api.put(`/righe/${rigaId}/criteri-mdo`, { esecutore_key: key, criterio }); toast.success("Criterio economico aggiornato"); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  return (
    <div className="border rounded-md" data-testid="esecutori-mdo">
      <div className="px-3 py-2 border-b bg-violet-50/60 dark:bg-violet-950/20 text-sm font-semibold">Manodopera per esecutore · criterio economico</div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[760px]">
          <thead><tr><Th>Esecutore</Th><Th>Criterio</Th><Th right>Ore</Th><Th right>Quantità eseguita</Th><Th right>Produttività</Th><Th right>Costo a ore</Th><Th right>Costo a misura</Th><Th right>Contabilizzato</Th></tr></thead>
          <tbody>{esecutori.map((e) => (
            <tr key={e.esecutore_key} className="border-t" data-testid={`esecutore-${e.esecutore_key}`}>
              <td className="py-1.5 px-2 text-xs">{e.nome}</td>
              <td className="py-1.5 px-2">
                <select className="h-7 rounded border px-1 text-xs bg-transparent" value={e.criterio} disabled={!canEdit} onChange={(ev) => setCrit(e.esecutore_key, ev.target.value)} data-testid={`criterio-select-${e.esecutore_key}`}>
                  <option value="ORE">A ore</option><option value="MISURA">A misura</option>
                </select>
                {e.criterio_impostato !== "True" && e.criterio_impostato !== true && <span className="ml-1 text-[10px] text-slate-400">(automatico)</span>}
              </td>
              <td className="py-1.5 px-2 text-right font-mono text-xs">{dec(e.ore, 0, 2)} h</td>
              <td className="py-1.5 px-2 text-right font-mono text-xs">{dec(e.quantita, 0, 4)} {um || ""}</td>
              <td className="py-1.5 px-2 text-right font-mono text-xs">{e.produttivita ? `${dec(e.produttivita, 0, 4)} ${um || ""}/h` : "—"}</td>
              <td className={`py-1.5 px-2 text-right font-mono text-xs ${e.criterio === "ORE" ? "" : "text-slate-400 line-through"}`}>{eur(e.importo_ore)}</td>
              <td className={`py-1.5 px-2 text-right font-mono text-xs ${e.criterio === "MISURA" ? "" : "text-slate-400 line-through"}`}>{eur(e.importo_misura)}{(e.senza_prezzo === "True" || e.senza_prezzo === true) && <span className="text-rose-600" title="Quantità senza prezzo a misura: costo da determinare"> + da det.</span>}</td>
              <td className="py-1.5 px-2 text-right font-mono text-xs font-semibold text-sky-800" data-testid={`contabilizzato-${e.esecutore_key}`}>{e.costo_contabilizzato === null ? <span className="text-rose-700">Da determinare ({e.da_determinare})</span> : eur(e.costo_contabilizzato)}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      <p className="px-3 py-1.5 text-[11px] text-slate-500">Il valore barrato è solo dato tecnico di confronto e non entra nei costi (nessun doppio conteggio).</p>
    </div>
  );
};
